import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import {
  IInvoice,
  IWorkLog,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";

type GetWorkLogStatusCellPropsParams = {
  workLog: IWorkLog;
  invoice?: IInvoice;
};

export function getWorkLogPayeeStatusCellProps({
  workLog,
  invoice
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  switch (workLog.status) {
    case WorkLogStatus.Approved:
      return {
        secondaryText: invoice
          ? `Invoiced #${invoice.invoiceNumber}`
          : undefined,
        pill: {
          text: "Submitted",
          theme: "success",
          icon: "check-circle"
        }
      };

    case WorkLogStatus.Draft:
    default:
      return {
        secondaryText: "Awaiting your submission",
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
